import { useI18n } from 'builder/hooks/useI18n'
import { useTypedSelector } from 'builder/hooks/useTypedSelector'
import { selectors as userSelectors } from 'builder/modules/user'
import { selectors } from 'builder/modules/resumeDistribution'

import { TRANSLATION } from '../constants'
import { Section } from '../styles'
import { Box, ActionsContainer, Text, ActionButton, LoadingButton, SpinnerButton } from './styles'

interface IProps {
  isLoading: boolean
  upgrade: () => void
}

export const ActionBanner = ({ upgrade, isLoading }: IProps) => {
  const { i18n } = useI18n()

  const candidate = useTypedSelector(selectors.candidate)
  const userAccountData = useTypedSelector(userSelectors.userData)

  const hasPremiumPlan = userAccountData?.hasPremiumFeatures
  const oneTimeRdSubscriptionType = candidate?.localSubscriptionType === 'one_time'
  const key = oneTimeRdSubscriptionType ? 'upgrade_text_campaign' : 'upgrade_text'

  if (hasPremiumPlan && !oneTimeRdSubscriptionType) return <></>

  return (
    <Section>
      <ActionsContainer>
        <Box>
          <Text>{i18n.t(`${TRANSLATION}.${key}`)}</Text>
        </Box>

        {isLoading ? (
          <LoadingButton>
            <SpinnerButton />
          </LoadingButton>
        ) : (
          <ActionButton onClick={upgrade}>{i18n.t(`${TRANSLATION}.upgrade_button`)}</ActionButton>
        )}
      </ActionsContainer>
    </Section>
  )
}
